import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

// 1. Renombramos las importaciones a PascalCase (primera letra en mayúscula)
import Index from './components/Index'
import Buscar from './components/Buscar'
import Venta from './components/Venta'
import Arrendar from './components/Arrendar'
import QuienesSomos from './components/QuienesSomos'
import Propiedades from './components/Propiedades'
import Masterinc from './components/controllers/Masterinc'
import AdminTop from './components/controllers/AdminTop'
import AdminTopImages from './components/controllers/AdminTopImages'
import AdminPropiedad from './components/controllers/AdminPropiedad'
import ConsultaPago from './components/ConsultaPago'

function App() {
  return (
    <BrowserRouter>
      <div>
        <Routes>
          {/* 2. Usamos los componentes con su respectiva mayúscula */}
          <Route path='' element={<Index />} />
          <Route path='Buscar' element={<Buscar />} />
          <Route path='Venta' element={<Venta />} />
          <Route path='Arrendar' element={<Arrendar />} />
          <Route path='QuienesSomos' element={<QuienesSomos />} />
          <Route path='propiedades/:id' element={<Propiedades />} />
          <Route path='ConsultaPago' element={<ConsultaPago />} />
          <Route path='controllers/Masterinc' element={<Masterinc />} />
          <Route path='controllers/AdminTop' element={<AdminTop />} />
          <Route path='controllers/AdminTopImages' element={<AdminTopImages />} />
          <Route path='controllers/AdminPropiedad' element={<AdminPropiedad />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;